import { render, staticRenderFns } from "./TituloFrequencia.vue?vue&type=template&id=a1c8c4ec&"
import script from "./TituloFrequencia.vue?vue&type=script&lang=js&"
export * from "./TituloFrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports